import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {RoutesModule} from './routes/routes.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {CoreModule} from './core/core.module';
import {ThemeModule} from './theme/theme.module';
import {SharedModule} from './shared/shared.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {DecryptInterceptor, DefaultInterceptor, GlobalErrorInterceptor} from './core';
import {ToastrModule} from 'ngx-toastr';
import {AgmCoreModule} from '@agm/core';
import {NgxEchartsModule} from 'ngx-echarts';
import {NgSelectModule} from '@ng-select/ng-select';
import {NgxCurrencyModule} from 'ngx-currency';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

/**
 * @class AppModule
 * @description This is the entry module of the system which has been called in main.ts
 */
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CoreModule,
    HttpClientModule,
    RoutesModule,
    ThemeModule,
    SharedModule,
    NgSelectModule,
    NgxCurrencyModule,
    AgmCoreModule.forRoot({
      // apiKey: 'AIzaSyDzYyUjMxFvRFDsZcW_jaxMO7RQ47aNpP0',
      apiKey: 'AIzaSyAffcIz1dwq1dTkg5I6jVZjE8pA3Tud190',
      libraries: ['places']
    }),
    BrowserAnimationsModule,
    NgxEchartsModule.forRoot({
      /**
       * This will import all modules from echarts.
       * If you only need custom modules,
       * please refer to [Custom Build] section.
       */
      echarts: () => import('echarts'),
    }),
    ToastrModule.forRoot({
    }),
    FontAwesomeModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: DefaultInterceptor, multi: true },
    {provide: HTTP_INTERCEPTORS, useClass: DecryptInterceptor, multi: true},
    { provide: HTTP_INTERCEPTORS, useClass: GlobalErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
